import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import QuestionList from "./QuestionList";

// The question bank page. QuestionList fetches, filters and pages its own data;
// this wrapper only shows the success message a save or delete redirects with.
// (It used to fetch the first page as well — a second, unused request that
// held the whole page behind a loading overlay until it returned.)
const AllQuestions = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState(null);

  useEffect(() => {
    if (location.state?.successMessage) {
      setSuccessMessage(location.state.successMessage);
      navigate(location.pathname, { replace: true });
    }
  }, [location.state, location.pathname, navigate]);

  useEffect(() => {
    if (!successMessage) return undefined;
    const timer = setTimeout(() => setSuccessMessage(null), 5000);
    return () => clearTimeout(timer);
  }, [successMessage]);

  return (
    <div>
      {successMessage && <div className="success-toast">{successMessage}</div>}
      <QuestionList />
    </div>
  );
};

export default AllQuestions;
